import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { USAepayCardPage } from './usaepay-card.page';

const routes: Routes = [
  {
    path: '',
    component: USAepayCardPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class USAepayCardPageRoutingModule {}
